<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Productions",
          icon: "bi bi-gear-wide-connected",
          route: "productions-index",
        },
        {
          label: "Nouvelle production",
          icon: "bi bi-send-plus-fill",
          route: "productions-create",
        },
        {
          label: "Saisir articles",
          icon: "bi bi-boxes",
          route: "productions-items-create",
        },
      ],
    };
  },
};
</script>
